"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sdk_1 = require("@cosmwasm/sdk");
const bcp_1 = require("@iov/bcp");
const crypto_1 = require("@iov/crypto");
const encoding_1 = require("@iov/encoding");
const { toBase64 } = encoding_1.Encoding;
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
function pubkeyToAddress(pubkey, prefix) {
    let sdkKey;
    if (pubkey.algo === bcp_1.Algorithm.Secp256k1) {
        sdkKey = {
            type: sdk_1.types.pubkeyType.secp256k1,
            value: toBase64(pubkey.data.length > 33 ? crypto_1.Secp256k1.compressPubkey(pubkey.data) : pubkey.data),
        };
    }
    else if (pubkey.algo === bcp_1.Algorithm.Ed25519) {
        sdkKey = {
            type: sdk_1.types.pubkeyType.ed25519,
            value: toBase64(pubkey.data),
        };
    }
    else {
        throw new Error(`Unsupported algorithm: ${pubkey.algo}`);
    }
    return sdk_1.pubkeyToAddress(sdkKey, prefix);
}
exports.pubkeyToAddress = pubkeyToAddress;
//# sourceMappingURL=address.js.map